import { ResetProvider } from "@store/utils/resetGlobalStore";

export const JotaiRoot = ({ children }: { children: React.ReactNode }) => {
  return <ResetProvider>{children}</ResetProvider>;
};
